import * as commonEnums from '../../../enums';

const ampUI: Accelerate.UIState = {
  contextParams: {},
  epicToken: '',
  confirm: {
    title: 'Remove Transaction',
    display: false
  },
  UIMode: null,
  UIView: commonEnums.UIViewEnum.AUTOMATE,
  coderConfig: []
};

export { ampUI };
